import React from 'react';

interface State {}

const OrdersCheckPaymentPage = () => {
  return <>OrdersCheckPaymentPage</>;
};

export default OrdersCheckPaymentPage;
